<template>
	<div
		class="g-block-insert-zone"
		@click.stop="$emit('insert', index)"
	>
		<div class="g-block-insert-zone__track">
			<div class="g-block-insert-zone__line"></div>
			<span class="g-block-insert-zone__label">插入此处</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'GBlockInsertZone',
		props: {
			index: {
				type: Number,
				required: true,
			},
		},
		emits: ['insert'],
	};
</script>

<style scoped lang="less">
	@insert-color: #285af9;

	.g-block-insert-zone {
		position: relative;
		z-index: 1;
		height: 15px;
		display: flex;
		align-items: center;
		cursor: pointer;
		user-select: none;

		&__track {
			position: relative;
			width: 100%;
			height: 16px;
			display: flex;
			align-items: center;
			opacity: 0;
			visibility: hidden;
			transition: opacity 0.15s, visibility 0.15s;
		}

		&:hover &__track {
			opacity: 1;
			visibility: visible;
		}
	}

	.g-block-insert-zone__line {
		position: absolute;
		left: 0;
		right: 0;
		top: 50%;
		height: 0;
		border-top: 1px dashed @insert-color;
		transform: translateY(-50%);

		&::before,
		&::after {
			content: '';
			position: absolute;
			top: -4px;
			width: 0;
			height: 0;
			border-top: 4px solid transparent;
			border-bottom: 4px solid transparent;
		}

		&::before {
			left: 0;
			border-right: 6px solid @insert-color;
		}

		&::after {
			right: 0;
			border-left: 6px solid @insert-color;
		}
	}

	.g-block-insert-zone__label {
		position: relative;
		z-index: 1;
		margin: 0 auto;
		padding: 0 8px;
		background: #fff;
		font-size: 12px;
		line-height: 1;
		color: @insert-color;
		white-space: nowrap;
	}
</style>
